import React from 'react';

import { TextInput } from './text-input';

export const RGInput = props => <TextInput {...props} />;
